var map = {
	"./assessment/assessment.png": "6677",
	"./avatar-extra.png": "17a2",
	"./file-icon.png": "651e",
	"./login/background.png": "b91e",
	"./login/cn.png": "fb00",
	"./login/cn_active.png": "0265",
	"./login/en.png": "386f",
	"./login/en_active.png": "3190",
	"./login/login_logo.png": "f7cf",
	"./login/reset-success.png": "dd31",
	"./logo.png": "9d64",
	"./manage/distributor.png": "c2c8",
	"./manage/school.png": "2e7a",
	"./no-content.png": "107e",
	"./not-found/404.png": "0f91",
	"./picture-book/audio-en.png": "4324",
	"./picture-book/audio-zh.png": "9c70",
	"./picture-book/back.png": "9db3",
	"./picture-book/book-corner.png": "0234",
	"./picture-book/lock.png": "629a",
	"./picture-book/page-button-active.png": "7df8",
	"./picture-book/page-button.png": "3f88",
	"./platform-icon.png": "663c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";